import React, { FC, useContext, useEffect, useState } from 'react';
import { Context } from "./index";
import { observer } from "mobx-react-lite";
import {BrowserRouter, Routes, Route, Navigate, useNavigate} from 'react-router-dom';
import AppRouter from './components/AppRouter';
import { useTranslation } from 'react-i18next';

const App = () => {
    const { t } = useTranslation();
    const { store } = useContext(Context);

    useEffect(() => {
        console.log(process.env.REACT_APP_API_URL)
        if (localStorage.getItem('token')) {
            store.checkAuth();
        }
    }, []);

    useEffect(() => {
        if (store.isAuth) {
            store.checkEntitiesInWork();
        }
    }, [store.isAuth]);

    if (store.isLoading) {
        return <div>{t('msg.loading')}</div>
    }

    return (
        <div>
            <AppRouter/>
        </div>
    );
};

export default observer(App);
